module.exports = __webpack_public_path__ + "img/block_3.b48b866f.webp";